
import { Component, Vue } from 'vue-property-decorator'
import { IndexManager } from '../manager'
import { IndexService } from '../service'
import SelectedCourseContent from './SelectedCourseContent.vue'

@Component({
  components: {
    SelectedCourseContent
  }
})

export default class extends Vue {
  private manager: IndexManager = new IndexManager(new IndexService())

  mounted () {
    this.manager.getSelectedCourseManager()
  }

  CourseDetails (item: any) {
    console.log(item)
    // localStorage.setItem('selectedCourse', JSON.stringify(item))
    const url = process.env.VUE_APP_PROD_URL
    window.location.href = (url + `/selectedCourse.html?item=${(JSON.stringify(item))}`)
  }
}
